import {  all } from 'redux-saga/effects';
import { uiWatcher } from './uiSaga';
import { loginWatcher } from './loginSaga';

export default function* rootSaga() {
    yield all([
        uiWatcher(),
        loginWatcher()
    ])
}
